<template>
  <div
    :class="[
      $blockClass(blockClass, 'video-container'),
      { 'images--no-padding': !padding },
    ]"
    class="responsive-video"
  >
    <span
      v-if="padding"
      :class="[
        $blockClass(blockClass, 'spacer'),
        { 'responsive-video__spacer--mobile': ratioDesktop }
      ]"
      class="responsive-video__spacer"
      :style="{ paddingBottom: getAspectRatio() }"
      aria-hidden="true"
    />

    <span
      v-if="padding && ratioDesktop"
      class="responsive-video__spacer responsive-video__spacer--desktop"
      :class="$blockClass(blockClass, 'spacer')"
      :style="{ paddingBottom: getAspectRatio(true) }"
      aria-hidden="true"
    />

    <video
      :class="[
        $blockClass(blockClass, 'video'),
        { 'lazyload': lazyload },
      ]"
      :src="lazyload ? '' : videoSrc"
      :data-src="videoSrc"
      :type="`video/${videoType}`"
      :preload="lazyload ? 'none' : 'auto'"
      class="responsive-video__video"
      :autoplay="autoplayEnabled"
      loop
      muted
      oncontextmenu="return false;"
      playsinline
    />
  </div>
</template>

<script>

/**
 * Vue: Video (video)
 * -----------------------------------------------------------------------------
 * A video component with spacers.
 *
 */
export default {
  name: 'ResponsiveVideo',

  props: {
    videoSrc: {
      type: String,
      default: '',
    },
    blockClass: {
      type: String,
      default: '',
    },
    lazyload: {
      type: Boolean,
      default: true,
    },
    ratio: {
      type: String,
      default: '',
    },
    ratioDesktop: {
      type: String,
      default: '',
    },
    padding: {
      type: Boolean,
      default: true,
    },
    autoplayEnabled: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {

    }
  },

  computed: {
    videoType() {
      return this.videoSrc?.split('.').pop().split('?').shift() || 'mp4'
    },
  },

  beforeMount() {
    // not empty
  },

  methods: {

    /**
     * Get aspect ratio.
     * @param {Boolean} desktop - Desktop breakpoint?
     * @returns {Number|Null}
     */
    getAspectRatio(desktop) {
      if (!this.padding) {
        return null
      }

      const ratio = desktop ? this.ratioDesktop : this.ratio

      let height = ''
      let width = ''

      /**
       * If ratio is passed as aspect ratio.
       */
      if (ratio && ratio.includes(':')) {
        height = ratio.split(':')[1] * 100.00
        width = ratio.split(':')[0]
      }

      return `${height / width}%`
    },
  },
}
</script>
